module.exports = __webpack_public_path__ + "static/media/lecture-error.9949c355.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture-error.png
// module id = 1994
// module chunks = 6